<template>
  <div id="page-claim-details">
    <commercial-claim-form
        v-model="model"
        ref="form"
        @add-dynamic-claim="addDynamicClaim"
        :loading="loading"
        card-title="Create Commercial Claim"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'commercial-claims-ipr.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommercialClaimForm from "@/views/pages/commercial-claims-ipr/CommercialClaimForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "CommercialClaimCreate",
  components: {
    CommercialClaimForm
  },
  mixins: [NotificationMixin],
  data() {
    return {
      model: {},
      loading: false,
      references: [
        'ProductCategory_RiskCode_FK',
        'ProductCategory_SubRiskCode_FK',
        'SalesCountryType_FK',
      ],
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      this.references.forEach((ref) => params[ref] = this.getReferenceId(ref))

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    addDynamicClaim(value) {
      this.references.push(value);
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = await this.getParams();

      try {
        const {data} = await this.$api.commercialClaimsIpr.create(params);
        this.notifySuccess('Commercial Claim created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Commercial Claim failed to be created');
        console.error(e)
      } finally {
      }
    }
  },
};
</script>

<style scoped>

</style>
